import styled from 'styled-components'

export const TooltipContainer = styled.div`
  position: fixed;
  left: ${({ tooltip }) => tooltip.x + 10}px;
  top: ${({ tooltip }) => tooltip.y + 10}px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: ${props => props.theme.spacing.sp4} ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.primitives.radius.radius1};
  pointer-events: none;
  z-index: 1000;
`
